import { connect } from 'react-redux'
import { IPickupNote, IStoreState, ITripEdit } from '../../types/index'
import DriverPnoteModal from '../../components/trips/trip-detail/note-modal/DriverPnoteModal'
import * as actions from '../../state/actions/trips'
import { RouteComponentProps, withRouter } from 'react-router-dom'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {
    history: ownProps.history,
    match: ownProps.match,
    currentTripId: ownProps.currentTripId,
    startMileage: ownProps.startMileage
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    saveNote: async (params: IPickupNote): Promise<any> => {
      return await dispatch(actions.saveData(params))
    },
    saveData: async (params: ITripEdit): Promise<any> => {
      return await dispatch(actions.saveData(params))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverPnoteModal)



// WEBPACK FOOTER //
// ./src/containers/trips/DriverPnoteModal.ts